export var ProgramRole;
(function (ProgramRole) {
    ProgramRole["Player"] = "PLAYER";
    ProgramRole["FreeAgent"] = "FREE_AGENT";
})(ProgramRole || (ProgramRole = {}));
export var OGProgramRole;
(function (OGProgramRole) {
    OGProgramRole["Player"] = "PLAYER";
    OGProgramRole["FreeAgent"] = "FREEAGENT";
})(OGProgramRole || (OGProgramRole = {}));
export var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["Unpaid"] = "UNPAID";
    PaymentStatus["Paid"] = "PAID";
    PaymentStatus["Refund"] = "REFUND";
    PaymentStatus["Partial"] = "PARTIAL";
    PaymentStatus["Void"] = "VOID";
    PaymentStatus["NATeamPays"] = "NA_TEAM_PAYS";
    PaymentStatus["NAFree"] = "NA_FREE";
    PaymentStatus["NAWaitlist"] = "NA_WAITLIST";
})(PaymentStatus || (PaymentStatus = {}));
export var RegistrationStatus;
(function (RegistrationStatus) {
    RegistrationStatus["Created"] = "CREATED";
    RegistrationStatus["Processing"] = "PROCESSING";
    RegistrationStatus["InError"] = "IN_ERROR";
    RegistrationStatus["Registered"] = "REGISTERED";
    RegistrationStatus["Removed"] = "REMOVED";
    RegistrationStatus["PendingInvite"] = "PENDING_INVITE";
    RegistrationStatus["SpotReserved"] = "SPOT_RESERVED";
})(RegistrationStatus || (RegistrationStatus = {}));
export var RegistrationType;
(function (RegistrationType) {
    RegistrationType["Team"] = "TEAM";
    RegistrationType["Staff"] = "STAFF";
    RegistrationType["Player"] = "PLAYER";
    RegistrationType["LegacyPlayer"] = "LEGACY_PLAYER";
    RegistrationType["LegacyStaff"] = "LEGACY_STAFF";
    RegistrationType["InvitePlayer"] = "INVITE_PLAYER";
    RegistrationType["InviteStaff"] = "INVITE_STAFF";
    RegistrationType["StaffFreeAgent"] = "STAFF_FREE_AGENT";
    RegistrationType["PlayerFreeAgent"] = "PLAYER_FREE_AGENT";
})(RegistrationType || (RegistrationType = {}));
export var RegistrationAtCapacityType;
(function (RegistrationAtCapacityType) {
    RegistrationAtCapacityType["All"] = "ALL";
    RegistrationAtCapacityType["Program"] = "PROGRAM";
    RegistrationAtCapacityType["Team"] = "TEAM";
})(RegistrationAtCapacityType || (RegistrationAtCapacityType = {}));
export var ProgramRegistrationSummaryItemType;
(function (ProgramRegistrationSummaryItemType) {
    ProgramRegistrationSummaryItemType["Team"] = "TEAM";
    ProgramRegistrationSummaryItemType["PlayerFreeAgent"] = "PLAYER_FREE_AGENT";
    ProgramRegistrationSummaryItemType["StaffFreeAgent"] = "STAFF_FREE_AGENT";
})(ProgramRegistrationSummaryItemType || (ProgramRegistrationSummaryItemType = {}));
export var TeamRegistrationSummaryItemType;
(function (TeamRegistrationSummaryItemType) {
    TeamRegistrationSummaryItemType["Player"] = "PLAYER";
    TeamRegistrationSummaryItemType["Staff"] = "STAFF";
})(TeamRegistrationSummaryItemType || (TeamRegistrationSummaryItemType = {}));
